<script>
import appConfig from "@/app.config";
import JSConfetti from 'js-confetti'
import { smartRaffleMethods } from "@/state/helpers";
import Swal from "sweetalert2";
/**
 * live draw component
 */
export default {
    page: {
        title: "live draw",
        meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
    components: {
    },
    data() {
        return {
            listOfWinners: [],
            tempListOfWinners: [],
            listOfBuffers: [],
            listOfEntries: [],
            prizeRaffle: null,
            raffle: {detail:null,prizes:[]},
            displayDetails:true,
            isRaffleDraw:false,
            raffleDrawWinner: null, // display winner after draw
            todayRaffleDraw: false,
            isIntermission: {status:false,count:0},
            drawEnd: false,
            entryListOfNames:[],
            listCount:0,
            listNames:[]
        }
    },
    methods: {
        ...smartRaffleMethods,
        openModal(modal=''){
            this.$bvModal.show(modal);
        },
        closeModal(modal=''){
            this.$bvModal.hide(modal);
        },
        popConfetti(){
            const jsConfetti = new JSConfetti()
            // jsConfetti.addConfetti({
            //     emojis: ['🌈', '⚡️', '💥', '✨', '💫', '🌸'],
            // })
            // jsConfetti.addConfetti({
            //     confettiColors: [
            //         '#ff0a54', '#ff477e', '#ff7096', '#ff85a1', '#fbb1bd', '#f9bec7',
            //     ],
            // })
            jsConfetti.addConfetti({
                confettiRadius: 6,
                confettiNumber: 600,
            })
        },
        async startRaffleDraw(){
            this.isRaffleDraw = true;
            await this.fetchLiveDrawDetails({"draw":true});
            this.playSound(require('@/assets/music/drumroll8s.mp3'));
            setTimeout(()=>{
                if(this.raffleDrawWinner != null){ 
                    this.entryListOfNames.splice(this.entryListOfNames.indexOf(this.raffleDrawWinner["customerName"]), 1)   
                }
                if(this.prizeRaffle != null){
                    if(this.prizeRaffle.triggerIntermission){
                        if(Object.prototype.hasOwnProperty.call(this.prizeRaffle, "intermissionCount")){
                            this.isIntermission.count = this.prizeRaffle.intermissionCount
                            this.isIntermission.status=true
                        }
                        this.countDownTimer();
                    }
                }
                this.listOfWinners = this.tempListOfWinners
                this.isRaffleDraw = false;
                this.popConfetti();
            },8000)//4500 and 8000
        },
        playSound (sound) {
            if(sound) {
                var audio = new Audio(sound);
                audio.play();
            }
        },
        async fetchLiveDrawDetails(body = {}){
            await this.actionSmartRaffle({
                action: "live-draw-details",
                body: body
            }).then((res)=>{
                console.log("res",JSON.stringify(res));
                this.prizeRaffle = res.message.activePrize
                this.raffle = {
                    detail : res.message.data,
                    prizes : res.message.prizes
                }
                this.todayRaffleDraw = res.message.hasActive
                this.listOfEntries = res.message.list
                this.listCount = res.message.listCount
                this.listNames = res.message.listNames
                if(!this.todayRaffleDraw){
                    this.openModal('bv-modal-no-active-raffle')
                }
                if(this.prizeRaffle == null){
                    this.drawEnd = true;
                    this.listOfWinners = res.message.winners;
                    return;
                }
                this.listOfBuffers = res.message.bufferWin
                if(Object.prototype.hasOwnProperty.call(body, "draw")){
                    this.tempListOfWinners = res.message.winners;
                    this.raffleDrawWinner = res.message.winners.length > 0 ? res.message.winners[0] : null
                }else{
                    this.listOfWinners = res.message.winners;
                }
                // for(let l of res.message.list){
                //     var c_name = l["businessName"] == null ? l["userName"]:l["businessName"]
                //     if(!this.entryListOfNames.includes(c_name)){
                //         this.entryListOfNames.push(c_name)
                //     }
                // }
                this.entryListOfNames = this.listNames;
                    console.log(JSON.stringify(this.entryListOfNames));
                // console.log(" ::: hey ::::",this.todayRaffleDraw);
            }).catch((err)=>{
                console.log("err", err);
                Swal.fire({
                    title: "Oops something went wrong",
                    text: `Please reload the page`,
                    icon: "warning",
                    showCancelButton: false,
                    cancelButtonText: "Cancel",
                    confirmButtonColor: "#c4297c",
                    cancelButtonColor: "#804997",
                    confirmButtonText: "Reload",
                    }).then((result) => {
                    if (result.value) {
                        this.$router.go(this.$router.currentRoute)
                    }
                });
            })
        },
        countDownTimer () {
            if (this.isIntermission.count > 0) {
                setTimeout(() => {
                    this.isIntermission.count -= 1
                    this.countDownTimer()
                }, 1000)
            }else{
                var nextPrize = this.raffle.prizes.findIndex(x => x.prizeId === this.prizeRaffle.prizeId);
                if((this.raffle.prizes.length -1) >= (nextPrize + 1)){
                    this.prizeRaffle = this.raffle.prizes[nextPrize + 1]
                }else{
                    this.drawEnd = true;   
                }
                this.raffleDrawWinner = null;
                this.isIntermission.status = false;
            }
        },
        testDraw(){
            this.actionSmartRaffle({
                action: "live-draw-details",
                body: {"draw":true}
            }).then((res)=>{
                console.log("res",JSON.stringify(res));
            }).catch((err)=>{
                console.log("err", err);
            })
        },
        testSwal(){
            Swal.fire({
                    title: "Oops something went wrong",
                    text: `Please reload the page`,
                    icon: "warning",
                    showCancelButton: false,
                    cancelButtonText: "Cancel",
                    confirmButtonColor: "#c4297c",
                    cancelButtonColor: "#804997",
                    confirmButtonText: "Reload",
                    }).then((result) => {
                    if (result.value) {
                        this.$router.go(this.$router.currentRoute)
                    }
                });
        }
    },
    computed: {
        isGrandPrize(){
            var status = false;
            try {
                if(this.prizeRaffle["prizeName"] == this.raffle.prizes[this.raffle.prizes.length - 1]["prizeName"]){
                    status = true;
                }
            } catch (error) {
                console.log(">>> error",error)
            }
            return status;
        }
    },
    async mounted(){
        await this.fetchLiveDrawDetails();
    }
}
</script>

<template>
    <div class="authentication-bg min-vh-100">
        <div class="bg-overlay bg-white"></div>

        <div class="container row">
            <div class="col-md-6">
                <div class="card grid-item h-100 mh-650">
                    <div class="card-body">
                        <div class="d-flex align-items-center justify-content-center">
                            <img
                                :src="require('@/assets/images/raffle-draw-icon.svg')" :class="{'no-raffle': !todayRaffleDraw}"
                            />
                        </div>
                        <h2 class="text-center mt-3">
                            <!-- Scroller Start -->
                            <div :class="[isRaffleDraw ? 'scroller' :'']">
                                <span class="w-100" v-if="isRaffleDraw">
                                    <span :key="index" v-for="(entry, index) in entryListOfNames"> 
                                        {{entry}} <br>
                                    </span>
                                </span>
                                <span class="w-100" v-else>
                                    <div v-if="raffleDrawWinner != null">
                                        <p>CONGRATULATIONS</p>
                                        <span class="text-capitalize"> 
                                            {{raffleDrawWinner["customerName"]}}
                                        </span>
                                    </div>
                                    <div v-else>
                                        <span class="text-capitalize">
                                            --
                                        </span>
                                    </div>
                                </span>
                            </div>
                            <!-- Scroller End[Customer Mobile Number] -->
                        </h2>
                        <div v-if="!isIntermission.status"> 
                            <button type="button" class="btn btn-primary w-100 btn-block mt-3" @click="startRaffleDraw" :disabled="isRaffleDraw" 
                            v-if="listCount != 0 && todayRaffleDraw && (!drawEnd && prizeRaffle != null) && prizeRaffle.noOfWinners > 0">
                                <span
                                    v-if="isRaffleDraw"
                                    class="spinner-grow spinner-grow-sm"
                                    role="status"
                                    aria-hidden="true"
                                ></span>
                                {{ prizeRaffle.limitStatus == 1 ? "":"Buffer" }}
                                Draw 
                                ({{ prizeRaffle.limitStatus == 1 ? prizeRaffle.noOfWinners - prizeRaffle.winCount : prizeRaffle.bufferNo - prizeRaffle.bufCount }})
                            </button>
                            <button type="button" class="btn btn-primary w-100 btn-block mt-3" disabled v-else>
                                Draw
                            </button>
                            <div class="mt-4 mb-4">
                                <div class="d-flex align-items-center justify-content-center">
                                    <img
                                        :src="require('@/assets/images/grand prize.svg')"  v-if="isGrandPrize"
                                    />
                                    <img
                                        :src="require('@/assets/images/winning prize.svg')"  v-else 
                                    />
                                </div>
                                <div class="d-flex align-items-center justify-content-center text-capitalize">
                                    <h2 class="fw-bold color-prize" v-if="todayRaffleDraw && (!drawEnd && prizeRaffle != null)">
                                        {{prizeRaffle["prizeName"]}}
                                    </h2>
                                    <h2 class="fw-bold color-prize" v-else>
                                        --
                                    </h2>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <button type="button" class="btn btn-primary w-100 btn-block mt-3" disabled>
                                Draw available in {{ isIntermission.count }}
                            </button>
                            <div class="mt-4 mb-4">
                                <div class="d-flex align-items-center justify-content-center">
                                    <img
                                        :src="require('@/assets/images/winning prize.svg')"
                                    />
                                </div>
                                <div class="d-flex align-items-center justify-content-center">
                                    <h2 class="fw-bold color-prize">
                                        --
                                    </h2>
                                </div>
                            </div>
                        </div>
                        <hr>

                        <span class="text-end text-primary c-pointer float-end" @click="displayDetails = !displayDetails"><u>{{displayDetails ? 'Hide':'Unhide'}}</u></span>
                        <p class="fw-bold m-0">
                            Raffle Details
                        </p>
                        <table class="table" v-if="displayDetails && raffle.detail != null">
                            <tr class="border-0 border-bottom">
                                <td>Number of Entries</td>
                                <td class="text-end" v-if="todayRaffleDraw">{{listCount}}</td>
                                <td class="text-end" v-else>--</td>
                            </tr>
                            <tr class="border-0 border-bottom">
                                <td>Raffle Identifier Name</td>
                                <td class="text-end" v-if="todayRaffleDraw">{{raffle.detail["raffleName"]}}</td>
                                <td class="text-end" v-else>--</td>
                            </tr>
                            <tr class="border-0 border-bottom">
                                <td>Draw Date</td>
                                <td class="text-end" v-if="todayRaffleDraw">{{raffle.detail["raffleDrawAt"] | formatDateOnly}}</td>
                                <td class="text-end" v-else>--</td>
                            </tr>
                            <tr class="border-0 border-bottom">
                                <td>Promo Duration</td>
                                <td class="text-end" v-if="todayRaffleDraw">{{raffle.detail["raffleStart"] | formatDateOnly }} - {{raffle.detail["raffleEnd"] | formatDateOnly }}</td>
                                <td class="text-end" v-else>--</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="card grid-item h-100 mh-650">
                    <div class="card-header text-dark fw-bold">
                        <button type="button" class="btn btn-primary float-end" @click="fetchLiveDrawDetails" v-if="false">
                            fetchLiveDrawDetails
                        </button>
                        <button type="button" class="btn btn-primary float-end" @click="testDraw" v-if="false">
                            testDraw
                        </button>
                        <button type="button" class="btn btn-primary float-end" @click="testSwal" v-if="false">
                            testSwal
                        </button>
                        <span class="text-warning"><i class="bx bx-trophy fw-bold me-1"></i></span> List of Winners
                    </div>
                    <!-- d-flex align-items-center justify-content-center -->
                    <div class="card-body p-0" style="overflow: scroll;">
                        <div :key="index" v-for="(winner, index) in listOfWinners" class="border-bottom py-2 text-capitalize" :class="`winner-${index}`"> 
                            <p class="text-center m-0">
                                {{winner["customerName"]}}<br>
                                <span :class="`sub-prize-${index > 4? 4:index}`">
                                    <span v-if="winner['mobileNo']!=null">
                                        {{winner["mobileNo"] | truncator(8,'****')}}
                                    </span>
                                    <span v-else>
                                        --
                                    </span>
                                </span>
                            </p>
                            <p class="d-flex align-items-center justify-content-center m-0 color-prize">
                                <i class="mdi mdi-buffer me-2" v-if="winner.isBuffer"></i> 
                                <!-- <i class="mdi mdi-medal-outline" v-else></i> -->
                                {{winner["prizeName"]}}
                            </p>
                        </div>
                        <div class="text-center text-muted h-100 d-flex align-items-center justify-content-center" v-if="listOfWinners.length == 0">
                            <div>
                                <i class="mdi mdi-clipboard-list-outline" style="font-size: 60px;"></i><br>
                                <span class="fw-bold">No Winner</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <b-modal id="bv-modal-no-active-raffle" title="winner" size="md" hide-header hide-title hide-footer hide-header-close>
                <span class="float-end c-pointer " @click="closeModal('bv-modal-no-active-raffle')"><i class="bx bx-x"></i></span>
                <div class="mt-4">
                    <div class="d-flex align-items-center justify-content-center">
                        <img
                            :src="require('@/assets/images/raffle-draw-icon.svg')" class="no-raffle"
                        />
                    </div>
                    <h4 class="text-center mt-4">No Active Raffle</h4>
                    <p class="text-center"><small class="text-muted"> There's no active raffle set today. Stay Tuned!</small></p>
                </div>
                <div class="d-flex align-items-center justify-content-center">
                    <button type="button" class="btn btn-primary w-100" @click="closeModal('bv-modal-no-active-raffle')">
                        Ok
                    </button>
                </div>
            </b-modal>
        </div>
        <!-- end container -->
    </div>
    <!-- end authentication section -->
</template>
<style>
/* Scroller styling */
.scroller {
  height: 1.2em;
  line-height: 1.2em;
  position: relative;
  overflow: hidden;
}
.scroller > span {
  position: absolute;
  top: 0;
  left:0;
  animation: slide 0.2s infinite;
  font-weight: bold;
  
}
@keyframes slide {
  0% {
    top: 0;
  }
  25% {
    top: -1.2em;
  }
  50% {
    top: -2.4em;
  }
  75% {
    top: -3.6em;
  }
}
.color-prize{
    color: #E39141;
}
.winner-0{
    font-size: 24px;
}
.winner-1{
    font-size: 22px;
}
.winner-2{
    font-size: 20px;
}
.winner-3{
    font-size: 18px;
}
.winner-4{
    font-size: 16px;
}
.sub-prize-0{
    font-size: 20px;
}
.sub-prize-1{
    font-size: 18px;
}
.sub-prize-2{
    font-size: 16px;
}
.sub-prize-3{
    font-size: 14px;
}
.sub-prize-4{
    font-size: 12px;
}
.mh-650{
    max-height: 650px;
}
.no-raffle{
    filter: grayscale(1);
}
</style>